export default {
  title: 'Ativar reservas',
  buttons: {
    cancel: 'Cancelar',
    activate: 'Ativar reservas',
  },
};
